export default "__VITE_ASSET__Buia$Tsw__"